import cn from 'classnames';
import { DSHelpText, DSHelpTextColor } from './DSHelpText';

export const helpText = (props: {
	color: DSHelpTextColor;
	error?: string;
	helpText?: string;
	disabled?: boolean;
	className?: string;
	cyErrorRef?: string;
}) => {
	const classes = cn('mt-2', props.className);

	if (props.error) {
		return (
			<DSHelpText cyErrorRef={props.cyErrorRef} color="error" className={classes}>
				{props.error}
			</DSHelpText>
		);
	}

	if (props.helpText) {
		return (
			<DSHelpText cyErrorRef={props.cyErrorRef} color={props.color} disabled={props.disabled} className={classes}>
				{props.helpText}
			</DSHelpText>
		);
	}
};
